module.exports = __webpack_public_path__ + "fonts/HelveticaNeueCyrThin.2313014.ttf";